module.exports = __webpack_public_path__ + "img/8_59.335a6d06.png";